import { AuthTokenData } from "../models/auth";

export interface AuthState {
    authenticated: boolean;
    initialized: boolean;
    clientId: string;
    clientSecret: string;
    accessToken?: string;
    refreshToken?: string;
    data?: AuthTokenData;
}

export const initialState: AuthState = {
    authenticated: false,
    initialized: false,
    clientId: "",
    clientSecret: "",
};



// WEBPACK FOOTER //
// ./src/store/AuthState.ts